import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent, onOpenCookieSettings } from "@/lib/consent";

export const CookieBanner = () => {
    const [open, setOpen] = useState(() => !getConsent());

    useEffect(() => onOpenCookieSettings(() => setOpen(true)), []);

    if (!open) return null;

    const choose = (value) => {
        setConsent(value);
        setOpen(false);
    };

    return (
        <div
            role="dialog"
            aria-label="Préférences cookies"
            className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-sm z-[60] bg-white border border-brand-line shadow-xl p-4 sm:p-5 animate-in fade-in slide-in-from-bottom-4 duration-300"
            data-testid="cookie-banner"
        >
            <p className="font-sans text-xs sm:text-sm text-brand-ink/75 leading-relaxed">
                Nous utilisons des cookies de mesure d'audience, uniquement avec votre accord.{" "}
                <Link to="/confidentialite" className="underline underline-offset-2 text-brand-primary" data-testid="cookie-banner-privacy-link">
                    En savoir plus
                </Link>
            </p>
            <div className="mt-3 sm:mt-4 flex gap-3">
                <button type="button" onClick={() => choose("denied")} className="ll-btn ll-btn-ghost text-sm flex-1 justify-center !py-2" data-testid="cookie-refuse-btn">
                    Refuser
                </button>
                <button type="button" onClick={() => choose("granted")} className="ll-btn ll-btn-primary text-sm flex-1 justify-center !py-2" data-testid="cookie-accept-btn">
                    Accepter
                </button>
            </div>
        </div>
    );
};
